import { random } from 'lodash';
import threeVerticalFuel from './three-vertical-fuel.json';
import threeHorizontalFuel from './three-horizontal-fuel.json';
import twoOpposedHoles from './two-opposed-holes.json';
import jumpsAndFullHole from './jumps-and-full-hole.json';
import obstacleLeft from './obstacle-left.json';
import obstacleRight from './obstacle-right.json';
import singlePowerup from './single-powerup.json';
import singleHole from './single-hole.json';
import lorenz from './lorenz.json';
import blockA from './block-a';
import blockB from './block-b';
import blockBB from './block-bb';
import blockC from './block-c';
import blockD from './block-d';
import easyLife from './easy-life';
import easyLifeHard from './easy-life-hard.json';
import flowerHoleA from './flower-hole-a.json';
import flowerHoleB from './flower-hole-b.json';
import flowerHoleC from './flower-hole-c.json';
import flowerHoleABig from './flower-hole-a-big.json';
import flowerHoleBBig from './flower-hole-b-big.json';
import flowerHoleCBig from './flower-hole-c-big.json';
import trickyHole from './tricky-hole.json';
import trickyObstacle from './tricky-obstacle.json';
import trickyObstacleReverse from './tricky-obstacle-reverse.json';
import trickyJump from './tricky-jump.json';
import trickyJumpReverse from './tricky-jump-reverse.json';
import saltoSaltoRamoFiume from './salto-salto-ramo-fiume.json';
import anziSi from './anzi-si.json';
// import enni1 from './enni1.json';
import FF1 from './FF1.json';
import LB1 from './LB1.json';
import LB2 from './LB2.json';
import LL1 from './LL1.json';
import LL2 from './LL2.json';
import PP1 from './PP1.json';
import PP2 from './PP2.json';
import PP3 from './PP3.json';
import TP2 from './TP2.json';
import letterE from './LetterE.json';
import letterG from './LetterG.json';
import letterO from './LetterO.json';
import letterR from './LetterR.json';
import letterV from './LetterV.json';
import spacingBlock from './spacing.json';

const blocksDefinitions = {
  blocks: [
    threeVerticalFuel,
    threeHorizontalFuel,
    twoOpposedHoles,
    jumpsAndFullHole,
    obstacleLeft,
    obstacleRight,
    singlePowerup,
    singleHole,
    // zigZagHoles,
    lorenz,
    blockA,
    blockB,
    blockBB,
    blockC,
    blockD,
    easyLife,
    flowerHoleA,
    flowerHoleB,
    flowerHoleC,
    flowerHoleABig,
    flowerHoleBBig,
    flowerHoleCBig,
    trickyHole,
    trickyObstacle,
    trickyObstacleReverse,
    trickyJump,
    trickyJumpReverse,
    saltoSaltoRamoFiume,
    anziSi,
    // enni1,
    FF1,
    LB1,
    LB2,
    letterE,
    letterG,
    letterO,
    letterR,
    letterV,
    LL1,
    LL2,
    PP1,
    PP2,
    PP3,
    TP2,
    easyLifeHard,
  ],

  getRandomBlock(level, isSpacing = false) {
    if (isSpacing) return spacingBlock;
    const availables = this.blocks.filter(
      (block) => (block.level.max === 0 || block.level.max >= level) && (block.level.min === 0 || block.level.min <= level),
    );
    const r = random(0, availables.length - 1, false);
    return availables[r];
  },
};

export default blocksDefinitions;
